import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Slot } from 'radix-ui'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useWithAffectedOGsHandler } from '@/entities/optimization-group'
import { useDeletePricingCampaignMutation } from '@/entities/pricing-campaign'

import { confirm } from '@/shared/components/ui/confirmer'

export const DeletePricingCampaign = ({
	pricingCampaignId,
	children,
}: {
	pricingCampaignId: string
	children: React.ReactNode
}) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const deletePricingCampaignMutation = useDeletePricingCampaignMutation({
		onSuccess() {
			queryClient.invalidateQueries({
				queryKey: ['products-counts-by-pc'],
			})
			queryClient.invalidateQueries({
				queryKey: ['pricing-campaigns'],
			})
			queryClient.invalidateQueries({
				queryKey: ['pricing-campaigns-overview'],
			})
		},
	})
	const deletePricingCampaign = useWithAffectedOGsHandler(
		deletePricingCampaignMutation
	)
	const handleDelete = async () => {
		const answer = await confirm({
			title: t('pc_detete_confirm_title'),
			description: t('pc_detete_confirm_subtitle'),
			actionText: t('general_delete'),
			cancelText: t('general_cancel'),
			ActionProps: {
				variant: 'destructive',
			},
		})
		if (answer) {
			toast.promise(deletePricingCampaign.mutateAsync(pricingCampaignId), {
				loading: t('toast.entity.deleting', {
					entity: t('entity.pricing_campaign'),
				}),
				success: t('deleting.success', {
					defaultValue: 'Deleted successfully',
				}),
				error: t('deleting.error', { defaultValue: 'Error while deleting' }),
			})
		}
	}

	return <Slot.Root onClick={handleDelete}>{children}</Slot.Root>
}
